import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { SidebarNavLink, SidebarWrapper } from '@components';
import { GlobalContext } from '@contexts';
import {
  ArrowLeftIcon,
  DatabaseIcon,
  LayersIcon,
  LayoutIcon,
  MapPinIcon,
  MonitorIcon,
  SettingsIcon,
  InboxIcon,
} from '@svgs';

const ProjectSidebar = (props) => {
  const { t, i18n } = useTranslation();
  const globals = useContext(GlobalContext);

  return (
    <SidebarWrapper>
      <div className="sb-sidebar-nav">
        {globals.visible.projectsView && (
          <div className="sb-sidebar-header">
            <Link
              to={`/dashboard/projects`}
              className="sb-sidebar-back-btn sb-flex"
            >
              <ArrowLeftIcon />
              Back to Projects
            </Link>
          </div>
        )}
        <ul>
          <li className="sb-sidebar-nav-title">Project</li>
          <SidebarNavLink to={`/dashboard/projects/${props.businessID}/sites`}>
            <MonitorIcon />
            Websites
          </SidebarNavLink>
          {globals.visible.projectLocationsView && (
            <SidebarNavLink
              to={`/dashboard/projects/${props.businessID}/locations`}
            >
              <MapPinIcon />
              Location details
            </SidebarNavLink>
          )}
          {globals.visible.projectContentDatabaseView && (
            <SidebarNavLink
              to={`/dashboard/projects/${props.businessID}/contentitems`}
              tooltip="Shared content across this project"
            >
              <DatabaseIcon />
              Content database
            </SidebarNavLink>
          )}
          {globals.visible.projectTemplatesView && (
            <SidebarNavLink
              to={`/dashboard/projects/${props.businessID}/templates`}
              tooltip="Manage the templates used within this project"
            >
              <LayoutIcon />
              Templates
            </SidebarNavLink>
          )}
          {globals.visible.projectFormLeadsView && (
            <SidebarNavLink
              to={`/dashboard/projects/${props.businessID}/formleads`}
            >
              <InboxIcon />
              Form leads
            </SidebarNavLink>
          )}
        </ul>
        <ul>
          {globals.visible.projectBulkEditView && (
            <>
              <li className="sb-sidebar-nav-title">Tools</li>
              <SidebarNavLink
                to={`/dashboard/projects/${props.businessID}/bulkedit`}
              >
                <LayersIcon />
                Bulk update
              </SidebarNavLink>
            </>
          )}
        </ul>
      </div>
      <ul className="sb-sidebar-footer">
        {(globals.visible.projectDataModelsView ||
          globals.visible.projectSettingsView) && (
          <>
            {globals.visible.projectSettingsView && (
              <SidebarNavLink
                to={`/dashboard/projects/${props.businessID}/settings`}
              >
                <SettingsIcon />
                Project settings
              </SidebarNavLink>
            )}
            {globals.visible.projectDataModelsView && (
              <SidebarNavLink
                to={`/dashboard/projects/${props.businessID}/datamodels`}
              >
                <DatabaseIcon />
                Manage fields
              </SidebarNavLink>
            )}
          </>
        )}
      </ul>
    </SidebarWrapper>
  );
};

export default ProjectSidebar;
